import { ConnectError } from '@bufbuild/connect';

import { NotFoundError } from '@/shared/config';
import { safeJSONParse } from '@/shared/lib';

export const isSessionAlreadyEndedError = (error: unknown): boolean => {
  if (!(error instanceof ConnectError)) {
    return false;
  }

  const { type, entity } = safeJSONParse(error.rawMessage);

  return type === 'NotFoundError' && entity === NotFoundError.SESSION;
};
